export default {
  install(_Vue) {
    const script = document.createElement("script");
    script.src = "https://www.gstatic.com/charts/loader.js";
    document.head.appendChild(script);
  },
};
